/* eslint-disable no-unused-vars */

import { Dayjs } from 'dayjs';

export enum SpecialPrickLanguageEnum {
    Null = 0,
    中文 = 1,
    英语 = 2,
    西文 = 3
}

export enum SpecialPrickTypeEnum {
    Null = 0,
    司机带 = 1,
    寄出去 = 2
}

export enum ApprovalNodeTypeEnum{
    // 开始
    Start = 1,
    // 中间
    Middle = 2,
    // 结束
    End = 3,
    // 拒绝
    Reject = 4,
    // 撤销
    Revocation = 5,
}

export interface ISpecialPrickHeaderDto {
    // 申请ID
    SpecialPrickId?: string | undefined | null,
    // 类型:1.司机带:2.寄出去
    Type: SpecialPrickTypeEnum,
    // 语言:1.中文:2.英语
    Language: SpecialPrickLanguageEnum,
    // 是否提交日期 YES , NO
    WhetherToSubmitDate: string,
    // 是否寄宣传单 - 寄出去用 , 不寄宣传单 , 寄宣传单
    WhetherToSendFlyer: string,
    SalesName: string,
    SalesPhone: string,
    // Sales上班时间
    SalesOfficeHours: string,
    TheTimeToMailItOut: null| Dayjs,
    TheTimeToMailItOutEnd: null| Dayjs,
    CreateTime?: Date | undefined | null,
    CreateDate?: Date | undefined | null,
    CreateName?: string,
    UpdateTime?: Date | undefined | null,
    UpdateName?: string
}

export interface ISpecialPrickCustomerInformationDto {
    Id?: string,
    SpecialPrickId?: string,
    SoNumber?: string,
    CustomerId: string,
    CustomerName?: string,
    PersonReceivingTheDocument?: string, // 收表人
    DoorNumberStreet?: string, // 门牌+街道
    City?: string,
    Province?: string, // 所在州
    PostCode?: string, // 邮编
    CreateTime?: Date,
    CreateDate?: Date,
    CreateName?: string,
    UpdateTime?: Date,
    UpdateName?: string
}

export interface ISpecialPrickMaterialInformationDto {
    Id?: string,
    SpecialPrickId?: string,
    MaterialNumber: string,
    MaterialDescription?: string,
    CustomItem: string,
    Cost: number,
    CustomCost: number,
    // 工厂信息
    Plant?: string,
    CreateTime?: Date,
    CreateDate?: Date,
    CreateName?: string,
    UpdateTime?: Date,
    UpdateName?: string
}

export interface ISpecialPrickDraftDto {
    // 草稿Id
    Id?: string,
    // 记录的哪个主键
    SpecialPrickId?: string,
    // 草稿描述
    DraftDescription: string,
    CreateTime?: Date,
    CreateDate?: Date,
    CreateName?: string,
    UpdateTime?: Date,
    UpdateName?: string
}
